import { render, staticRenderFns } from "./icon-componets.vue?vue&type=template&id=5d1051ca&"
import script from "./icon-componets.vue?vue&type=script&lang=js&"
export * from "./icon-componets.vue?vue&type=script&lang=js&"
import style0 from "./icon-componets.vue?vue&type=style&index=0&id=5d1051ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports